@if (showSpinner$ | async) {
  <app-spinner></app-spinner>
}
<router-outlet></router-outlet>
<app-toast-container />
